import { useEffect, useState } from 'react';
import { useGetUnits } from 'api/units';
import { Unit, UnitsParams } from 'api/units/units.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { UNIT_LABEL } from 'pages/rates/components/RatesForm/RatesForm.consts';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function UnitAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const { data, loading, getUnits } = useGetUnits();
  const [options, setOptions] = useState<Unit[]>([]);
  const [unitsParams, setUnitsParams] = useState<UnitsParams>({
    filterText: '',
    pageNumber: 1,
    resultSize: 25,
  });

  useEffect(() => {
    getUnits(unitsParams);
  }, [getUnits, unitsParams]);

  useEffect(() => {
    if (data?.length) {
      const fetchedOptions = data.map((unit) => ({
        id: unit.id,
        lock: unit.lock,
        comment: unit.comment,
        description: unit.description,
        enabled: unit.enabled,
        code: unit.code,
        loadFCL: unit.loadFCL,
        loadLCL: unit.loadLCL,
        loadFTL: unit.loadFTL,
        loadLTL: unit.loadLTL,
        translations: unit.translations,
        subUnitsCount: unit.subUnitsCount,
      }));
      const filteredOptions = fetchedOptions.filter(
        (activity) => activity.enabled,
      );
      setOptions((prev) => [...prev, ...filteredOptions]);
    }
  }, [data]);

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={200}
      label={UNIT_LABEL}
      value={formProps.field.value}
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(o) => o.code}
      handleSearchChange={handleChange(setOptions, setUnitsParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setUnitsParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setUnitsParams,
        formProps.field.onBlur,
      )}
    />
  );
}
